import { render, staticRenderFns } from "./inputData.vue?vue&type=template&id=1e3880a6&scoped=true&"
import script from "./inputData.vue?vue&type=script&lang=js&"
export * from "./inputData.vue?vue&type=script&lang=js&"
import style0 from "./inputData.vue?vue&type=style&index=0&id=1e3880a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3880a6",
  null
  
)

export default component.exports